module.exports = __webpack_public_path__ + "img/listings-event-banner.7888b427.png";